import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import image from "../../../assets/img/marifer.png";

const styles = StyleSheet.create({
  image2: {
    position: "absolute",
    objectPosition: "0",
    zIndex: -999,
    width: "320px",
    height: "320px",
    opacity: 0.2,
  },
  image: {
    position: "relative",
    objectFit: "cover",
    zIndex: -999,
    width: "120px",
    height: "120px",
    paddingLeft: 0,
    opacity: 0.9,
  },
  header: {
    color: "#ff0080",
    textTransform: "uppercase",
    marginTop: 15,
    paddingLeft: 50,
    fontSize: "18pt",
    fontWeight: "extrabold",
  },
  page: {
    fontSize: "14pt",
    padding: 10,
  },
  mainSection: {
    flexDirection: "row",
    textAlign: "center",
    height: "7.975cm",
  },
  section1: {
    padding: 8,
    textAlign: "center",
    width: "7cm",
    height: "100%",
    backgroundColor: "white",
    border: 1,
    borderColor: "#0A83F5",
    lineHeight: 1.5,
    fontSize: "10pt",
  },
  section2: {
    padding: 8,
    lineHeight: 4,
    border: 1,
    borderColor: "#0A83F5",
    width: "14.6cm",
    height: "100%",
    backgroundColor: "white",
  },
  viewer: {
    width: "100%",
    height: window.innerHeight,
  },
});

const now = new Date();
const yyyy = now.getFullYear();
const mm = String(now.getMonth() + 1).padStart(2, "0");
const dd = String(now.getDate()).padStart(2, "0");
const hours = String(now.getHours()).padStart(2, "0");
const minutes = String(now.getMinutes()).padStart(2, "0");
const seconds = String(now.getSeconds()).padStart(2, "0");

const groupRolls = (data) => {
  // Agrupar por nombre + código
  const grouped = Object.values(
    data.reduce((acc, item) => {
      const key = `${item.cloth.name}-${item.cloth.code}`;
      if (!acc[key]) {
        acc[key] = {
          name: item.cloth.name,
          code: item.cloth.code,
          count: 0,
          totalMeters: 0,
          totalKg: 0,
        };
      }
      acc[key].count += 1;
      acc[key].totalMeters += parseFloat(item.meters) || 0;
      acc[key].totalKg += parseFloat(item.totalKg) || 0;
      return acc;
    }, {})
  );

  // Ordenar de menor a mayor por nombre
  grouped.sort((a, b) => a.name.localeCompare(b.name));

  // Opcional: redondear a 2 decimales
  grouped.forEach((g) => {
    g.totalMeters = Math.round(g.totalMeters * 100) / 100;
    g.totalKg = Math.round(g.totalKg * 100) / 100;
  });

  return grouped;
};

const ReportRollsPdf = ({ rollsData, rollsDataDelete }) => {
  const groupedRolls = groupRolls(rollsData);

  return (
    <PDFViewer style={styles.viewer}>
      <Document>
        <Page size="LETTER" style={styles.page}>
          {/* --- Primer sección --- */}
          <View style={styles.mainSection}>
            <View>
              <Image style={styles.image} src={image} />
            </View>
            <View>
              <Text style={styles.header}>{"Reporte de Rollos General"}</Text>
            </View>
          </View>

          {/* --- Segunda sección (resumen) --- */}
          <View
            style={{
              fontSize: 10,
              flexDirection: "row",
              textAlign: "center",
              wordWrap: "word-break",
              paddingLeft: 295,
              marginTop: -150,
              paddingBottom: 5,
            }}
          >
            <View>
              <View>
                <Text
                  style={{
                    border: 1,
                    padding: 1,
                    width: 75,
                    textAlign: "center",
                  }}
                >
                  {"EN ALMACEN"}
                </Text>
              </View>
              <Text
                style={{
                  border: 1,
                  width: 75,
                  padding: 1,
                  height: 45,
                  color: "gray",
                  textAlign: "center",
                }}
              >
                {Number(rollsData.length)}
              </Text>
            </View>
            <View>
              <View>
                <Text
                  style={{
                    border: 1,
                    padding: 1,
                    width: 75,
                    textAlign: "center",
                  }}
                >
                  {"CORTADOS"}
                </Text>
              </View>
              <Text
                style={{
                  border: 1,
                  width: 75,
                  padding: 1,
                  height: 45,
                  color: "gray",
                  textAlign: "center",
                }}
              >
                {Number(rollsDataDelete.length)}
              </Text>
            </View>
            <View style={{ textAlign: "left", width: 150, color: "#111" }}>
              <Text style={{ border: 1, fontSize: 9, padding: 1, height: 20, paddingLeft:30 }}>
                {`${yyyy}-${mm}-${dd} ${hours}:${minutes}:${seconds}`}
              </Text>
              <Text></Text>
              {/* <Text
                style={{ border: 1, fontSize: 9, padding: 1, height: 20 }}
              ></Text>
              <Text
                style={{ border: 1, fontSize: 9, padding: 1, height: 20 }}
              ></Text> */}
            </View>
          </View>

          {/* --- Tercera sección (tabla) --- */}
          <View style={{ border: 1, marginTop: 1 }}>
            {/* <View style={{ alignItems: "center" }}>
              <Image src={image} style={styles.image2} />
            </View> */}

            {/* Encabezado tabla */}
            <View
              style={{
                flexDirection: "row",
                textAlign: "center",
                fontWeight: "extrabold",
                fontSize: "11pt",
                backgroundColor: "#e6e6e6",
                height: 20,
              }}
            >
              <View style={{ width: "100%", border: 1 }}>
                <Text style={{ color: "#000" }}>{"Rollos por Tela"}</Text>
              </View>
            </View>

            {/* Sub-encabezado */}
            <View
              style={{
                flexDirection: "row",
                textAlign: "center",
                fontSize: "10pt",
                color: "#000111",
                height: 20,
                backgroundColor: "#f9c6cf",
              }}
            >
              <View style={{ width: "5%", border: 1, padding: "3px" }}>
                <Text>{"No."}</Text>
              </View>
              <View style={{ width: "45%", border: 1, padding: "3px" }}>
                <Text>{"Nombre y color de la Tela"}</Text>
              </View>
              <View style={{ width: "13%", border: 1, padding: "3px" }}>
                <Text>{"Codigo"}</Text>
              </View>
              <View style={{ width: "13%", border: 1, padding: "3px" }}>
                <Text>{"Rollos"}</Text>
              </View>
              <View style={{ width: "13%", border: 1, padding: "3px" }}>
                <Text>{"Kg"}</Text>
              </View>
              <View style={{ width: "13%", border: 1, padding: "3px" }}>
                <Text>{"Metros"}</Text>
              </View>
            </View>

            {/* Filas agrupadas */}
            {groupedRolls.length === 0 ? (
              <View
                style={{
                  flexDirection: "row",
                  textAlign: "center",
                  fontSize: "10pt",
                  color: "#000111",
                }}
              >
                <View style={{ width: "100%", border: 1, padding: "3px" }}>
                  <Text>{"No hay datos para mostrar."}</Text>
                </View>
              </View>
            ) : (
              groupedRolls.map((p, idx) => (
                <View
                  key={idx}
                  style={{
                    flexDirection: "row",
                    textAlign: "center",
                    fontSize: "8pt",
                    color: "#000111",
                  }}
                >
                  <View style={{ width: "5%", border: 1, padding: "3px" }}>
                    <Text>{idx + 1}</Text>
                  </View>
                  <View style={{ width: "45%", border: 1, padding: "3px" }}>
                    <Text>{p.name}</Text>
                  </View>
                  <View style={{ width: "13%", border: 1, padding: "3px" }}>
                    <Text>{p.code}</Text>
                  </View>
                  <View style={{ width: "13%", border: 1, padding: "3px" }}>
                    <Text>{p.count}</Text>
                  </View>
                  <View style={{ width: "13%", border: 1, padding: "3px" }}>
                    <Text>{p.totalKg}</Text>
                  </View>
                  <View style={{ width: "13%", border: 1, padding: "3px" }}>
                    <Text>{p.totalMeters}</Text>
                  </View>
                </View>
              ))
            )}
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};

export default ReportRollsPdf;
